var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCornerOneFrame1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 285,
    viewBox: "0 0 400 285",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M256.692 125.387H62.694C28.0694 125.387 0.000518799 97.3179 0.000518799 62.6932C0.000518799 28.0686 28.0693 -0.000228882 62.694 -0.000228882H194.739C228.955 -0.000228882 256.692 27.7374 256.692 61.9535V125.387Z",
    fill: "#007580"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M125.387 205.281L62.6935 205.281L-5.48084e-06 205.281C-2.45385e-06 170.657 28.0688 142.588 62.6935 142.588C97.3181 142.588 125.387 170.657 125.387 205.281Z",
    fill: "#FF7F50"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M125.387 222.307L62.6935 222.307L-5.48084e-06 222.307C-2.45385e-06 256.931 28.0688 285 62.6935 285C97.3181 285 125.387 256.931 125.387 222.307Z",
    fill: "#60C2A5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M399.094 62.8771L336.4 62.8771L273.707 62.8771C273.707 28.2524 301.776 0.183596 336.401 0.183599C371.025 0.183602 399.094 28.2524 399.094 62.8771Z",
    fill: "#60C2A5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M131.305 148.504L193.999 148.504L256.692 148.504C256.692 183.128 228.624 211.197 193.999 211.197C159.374 211.197 131.305 183.128 131.305 148.504Z",
    fill: "#284993"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCornerOneFrame1);
export default __webpack_public_path__ + "static/media/CornerOneFrame1.91d4eaf3f7404a15656fed0b0ad32e3e.svg";
export { ForwardRef as ReactComponent };